import Navbar from "../components/site/Navbar";
import Hero from "../components/site/Hero";
import Services from "../components/site/Services";
import Process from "../components/site/Process";
import Pricing from "../components/site/Pricing";
import Work from "../components/site/Work";
import Testimonials from "../components/site/Testimonials";
import FAQ from "../components/site/FAQ";
import Contact from "../components/site/Contact";
import Footer from "../components/site/Footer";

export default function Landing() {
  return (
    <div className="bg-[#FAFCFA]" data-testid="landing-page">
      <Navbar />
      <main>
        <Hero />
        <Services />
        <Process />
        <Pricing />
        <Work />
        <Testimonials />
        <FAQ />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
